import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import { User, KeyRound } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLoginNew = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ username: '', password: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`${API}/auth/admin/login`, formData);
      localStorage.setItem('admin_token', response.data.token);
      toast.success('Admin login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'linear-gradient(135deg, #F8FAFC 0%, #E2E8F0 100%)' }}>
      <Card className="w-full max-w-md shadow-xl border-slate-100">
        <CardHeader className="text-center space-y-3 pb-6">
          <CardTitle className="text-2xl font-bold" style={{ fontFamily: 'Manrope, sans-serif' }}>Admin Panel</CardTitle>
          <CardDescription className="text-base">PrimeSwift Management</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-2">
              <Label className="text-sm font-medium">Username</Label>
              <div className="relative"><User className="absolute left-3 top-3 h-5 w-5 text-slate-400" />
                <Input data-testid="admin-username-input" placeholder="Enter username" className="pl-10 h-12 bg-slate-50" value={formData.username} onChange={(e) => setFormData({...formData, username: e.target.value})} required />
              </div>
            </div>
            <div className="space-y-2">
              <Label className="text-sm font-medium">Password</Label>
              <div className="relative"><KeyRound className="absolute left-3 top-3 h-5 w-5 text-slate-400" />
                <Input data-testid="admin-password-input" type="password" placeholder="Enter password" className="pl-10 h-12 bg-slate-50" value={formData.password} onChange={(e) => setFormData({...formData, password: e.target.value})} required />
              </div>
            </div>
            <Button type="submit" data-testid="admin-login-button" className="w-full h-12 bg-slate-900 hover:bg-slate-800 text-white text-base font-semibold rounded-full" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </Button>
            <div className="text-center pt-2 space-y-2">
              <button type="button" onClick={() => navigate('/admin/forgot-password')} className="text-sm text-orange-500 hover:text-orange-600 block w-full">Forgot Password?</button>
              <button type="button" onClick={() => navigate('/admin/register')} className="text-sm text-slate-600 hover:text-slate-900 block w-full">New admin? Register here</button>
            </div>
            <div className="text-center pt-1">
              <button type="button" onClick={() => navigate('/mobileapp')} className="text-sm text-slate-500 hover:text-orange-500">Back to driver portal</button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLoginNew;
